import React, { useState, useMemo, useEffect } from 'react';
import _ from 'lodash';
import {
  ButtonBase,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { AddIcon, CheckIcon, EditIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { SettingRemarksAddoption, SettingRemarksEditoption } from '../../PopWindows/SettingPops';
import { bedStatusAPI } from '../../../../../apis';
const useStyles = makeStyles((theme) => ({
  root: {
    margin: '0 3.437rem',
    background: '#fff',
    padding: '1.875rem',
    borderRadius: '0 0.93rem 0.93rem 0.93rem',
  },
  bedStatusSetting: {
    fontSize: '1.875rem',
    fontWeight: 'bold',
    lineHeight: '1',
    color: '#2e4469',
  },
  table: {
    position: 'relative',
    minWidth: '45rem',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '1.125rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0 1rem ',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '10',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
        textTransform: 'uppercase',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        padding: '1rem',
        backgroundColor: '#fff',
        fontSize: '0.875rem',
      },
      '& .MuiTableCell-root:nth-child(1)': {
        paddingLeft: '1.313rem',
      },
      '& .MuiTableCell-root:nth-last-child(1)': {
        paddingRight: '1.883rem',
      },
    },
    '& .MuiTableBody-root': {
      '& :hover': {
        backgroundColor: '#f5faff',
      },
      '& > .MuiTableRow-root': {
        borderBottom: '1px solid #E6E8E9',
      },
      '& .MuiTableCell-root': {
        height: '3.5rem',
        fontFamily: 'NotoSans-Medium',
      },
      '& .MuiTableCell-root:nth-child(1)': {
        paddingLeft: '1.313rem',
      },
      '& .MuiTableCell-root:nth-last-child(1)': {
        paddingRight: '1.883rem',
      },
    },
  },
  status: {
    width: '0.625rem',
    height: '0.625rem',
    display: 'inline-block',
    backgroundColor: '#28d2ab',
    borderRadius: '50%',
    marginRight: '0.563rem',
  },
  editBtn: {
    width: '2.25rem',
    height: '2.25rem',
    minWidth: '0',
    backgroundColor: '#4c93ff',
    borderRadius: '0.625rem',
    color: '#fff',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  editIcon: {
    fontSize: '1rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  tableHead: {
    whiteSpace: 'nowrap',
  },
  add: {
    width: '5.688rem',
    height: '3rem',
    background: '#538fff',
    color: '#fff',
    borderRadius: '0.625rem',
    fontWeight: '500',
    fontFamily: 'NotoSans-Medium',
  },
  checkIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: '#28d2ab',
  },
}));

export default function SettingDiagnosis({
  handleDoubleClick,
  rouList,
  userInfo,
  bottomFlag,
  setBottomFlag,
  hasScrollbar,
  size,
}) {
  const classes = useStyles();
  const [pageNum, setPageNum] = useState(1);
  const [remarkList, setRemarkList] = useState([]);
  const [total, setTotal] = useState(null);

  // remark API
  const remarkAPI = async ({ pageNo = 1, pageSize = size }) => {
    try {
      const { result } = await bedStatusAPI.getBsRemarkList({ pageSize, pageNo });
      setTotal(result.count);
      pageNo === 1 ? setRemarkList([...result.data]) : setRemarkList([...remarkList, ...result.data]);
    } catch (error) {
      console.log('-----Get Remarks error----->', error);
    }
  };

  useEffect(() => {
    if (bottomFlag && total) {
      setBottomFlag(false);
      let num = total - pageNum * size;
      if (num > 0) {
        (async () => {
          await remarkAPI({ pageNo: pageNum + 1 });
          setPageNum(pageNum + 1);
        })();
      }
    }
  }, [bottomFlag]);

  useEffect(() => {
    if (!hasScrollbar()) {
      let num = total - pageNum * size;
      if (num > 0) {
        (async () => {
          await remarkAPI({ pageNo: pageNum + 1 });
          setPageNum(pageNum + 1);
        })();
      }
    }
  }, [remarkList]);

  useEffect(() => {
    if (userInfo.flag) {
      (async () => {
        await remarkAPI({});
      })();
    }
  }, [rouList]);

  const rows = useMemo(() => {
    let list = [];
    if (Array.isArray(remarkList) && remarkList.length > 0) {
      list = _.map(remarkList, (item) => {
        return { ...item, id: item.remarkId, option: item.remark, active: item.isActive };
      });
    }
    return list;
  }, [remarkList]);

  const reCallAPI = async () => {
    await remarkAPI({ pageSize: size * pageNum });
  };

  // add butttons
  const [isAddOption, setIsAddOption] = useState(false);
  const addOptionHandle = () => {
    setIsAddOption(true);
  };
  const addPopProps = {
    open: isAddOption,
    closePop: () => {
      setIsAddOption(false);
    },
    secondBtnClick: async ({ isActive, name }) => {
      try {
        await bedStatusAPI.createBsRemark({
          isActive: isActive ? 1 : 0,
          remark: name,
        });
        await reCallAPI();
      } catch (error) {
        console.log('-----Add Remark error----->', error);
      }
    },
  };

  // edit button
  const [editState, setEditState] = useState({
    open: false,
    inputName: null,
    active: false,
  });
  const editPopProps = {
    open: editState.open,
    closePop: () => {
      setEditState({ ...editState, open: false });
    },
    firstBtnClick: async () => {
      try {
        await bedStatusAPI.deleteBsRemark({ id: editState.row.remarkId });
        await reCallAPI();
      } catch (error) {
        console.log('-----Delete Remark error----->', error);
      }
    },
    secondBtnClick: async ({ isActive, name }) => {
      try {
        await bedStatusAPI.updateBsRemark({
          isActive: isActive,
          remark: name,
          remarkId: editState.row.remarkId,
        });
        await reCallAPI();
      } catch (error) {
        console.log('-----Edit Remark error----->', error);
      }
    },
    inputName: editState.inputName,
    active: editState.active,
  };
  const showEditPop = (inputName, active, row) => {
    return () => {
      setEditState({ ...editState, open: true, inputName, active, row: row });
    };
  };

  return (
    <div className={classes.root}>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ButtonBase className={classes.add} onClick={addOptionHandle} id="bed_setting_add_btn1">
          <AddIcon style={{ fontSize: '1rem', marginRight: '0.313rem' }} />
          {i18n.t('BEDSTATUS_ADD')}
        </ButtonBase>
      </div>
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead} id="bed_setting_table_head">
            <TableRow>
              <TableCell align="left" style={{ wordBreak: 'break-all' }}>
                {i18n.t('BEDSTATUS_REMARKS_CONTENT')}
              </TableCell>
              <TableCell align="center">{i18n.t('BEDSTATUS_ACTIVE')}</TableCell>
              <TableCell align="right">{i18n.t('BEDSTATUS_EDIT')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody} id="bed_setting_table_body">
            {rows.map((row, rowIndex) => {
              const { option, active } = row;
              return (
                <TableRow
                  key={row.id}
                  onDoubleClick={() => {
                    handleDoubleClick(option, active, row, showEditPop);
                  }}
                  id={`bed_setting_table_row${rowIndex}`}
                >
                  <TableCell align="left">{option}</TableCell>
                  <TableCell align="center">{active ? <CheckIcon className={classes.checkIcon} /> : ''}</TableCell>
                  <TableCell align="right">
                    <ButtonBase
                      className={classes.editBtn}
                      onClick={showEditPop(option, active, row)}
                      id={`bed_setting_edit_btn${rowIndex}`}
                    >
                      <EditIcon className={classes.editIcon} />
                    </ButtonBase>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {addPopProps.open ? <SettingRemarksAddoption {...addPopProps} /> : ''}
      {editPopProps.open ? <SettingRemarksEditoption {...editPopProps} /> : ''}
    </div>
  );
}
